import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router, UrlSerializer } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable, tap } from 'rxjs';
import { UserModel } from '../../helpers/objects/dto/user/user-model';
import { ContactsModel } from '../../helpers/objects/dto/contacts/contacts-model';
import { UserRequestModel } from '../../helpers/objects/request/user/user-request-model';
import { UsersListResponseModel } from '../../helpers/objects/response/users-list/users-list-response-model';
import { UserCreateRequestModel } from '../../helpers/objects/request/user-create/user-create-request-model';
import { ChangePasswordRequestModel } from '../../helpers/objects/request/change-password/change-password-request-model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  UserInfo: UserModel = new UserModel();

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
    private serializer: UrlSerializer,
    private translateService: TranslateService,
    private router: Router
  ) {}

  get(id: string, loggedUser: boolean = false): Observable<UserModel> {
    return this.http.get<any>(this.appConfig.api + 'users/' + this.appConfig.apiPartnershipId + '/' + id).pipe(
      map((response) => response.body.user as UserModel),
      tap((data) => {
        if (loggedUser) {
          this.UserInfo = data;
        }
      })
    );
  }

  getContacts(): Observable<ContactsModel[]> {
    return this.http.get<any>(this.appConfig.api + 'contacts/' + this.appConfig.apiPartnershipId).pipe(
      map((response) => {
        return response.body.contacts as ContactsModel[];
      })
    );
  }

  updateUser(person: UserRequestModel): Observable<UserRequestModel> {
    return this.http.put<any>(this.appConfig.api + 'users/' + this.appConfig.apiPartnershipId + '/' + person.id, person).pipe(
      map((response) => {
        return response.body as UserRequestModel;
      })
    );
  }

  updateUserPassword(data: ChangePasswordRequestModel, personId: string): Observable<any> {
    const dataToSave = {
      password: data.password,
      newPassword: data.newPassword
    };
    return this.http.put<any>(this.appConfig.api + 'users/' + this.appConfig.apiPartnershipId + '/' + personId + '/password', dataToSave).pipe(
      map((response) => {
        return response.body;
      })
    );
  }

  createUser(person: UserCreateRequestModel): Observable<any> {
    return this.http.post<any>(this.appConfig.api + 'register/' + this.appConfig.apiPartnershipId, person).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getUsersList(filter: any): Observable<UsersListResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'users/' + this.appConfig.apiPartnershipId, { params: httpParams })
      .pipe(map((response) => response.body as UsersListResponseModel));
  }

  download(filter: any): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return this.appConfig.api + 'users-worksheet/' + this.appConfig.apiPartnershipId + '?' + (this.serializer.serialize(query).split('?')[1] || '');
  }
}
